import { WebhookEventType } from 'utils/models/webhook.model';

// Enum declaration order is the processing flow (SPP-859).
const EVENT_ORDER: string[] = Object.values(WebhookEventType);

const rank = (event: string) => {
  const index = EVENT_ORDER.indexOf(event);
  return index === -1 ? EVENT_ORDER.length : index;
};

// Stored order is selection order, so sort for display. Unknown events,
// including '*', follow known ones in their stored order (stable sort).
export const sortWebhookEvents = (events: string[]): string[] =>
  [...events].sort((a, b) => rank(a) - rank(b));
